import React from "react";
import CEOandDirectorImg from "../../../Assets/Images/our-team/INDRANI SARKAR.png";

const OurTeamInfoContainer2 = () => {
  return (
    <div className="w-full overflow-hidden">
      <div className="pt-8 md:pt-12 pb-8 md:pb-12">
        <div
          className="bg-[#ECF8FB] px-4 sm:px-6 md:px-10 py-8 md:py-12"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 lg:gap-8 items-center">
              {/* Content Section - Now first on desktop, second on mobile */}
              <div
                className="lg:col-span-3 order-2 lg:order-1"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <div className="space-y-4 lg:space-y-6">
                  <p className="text-[#585858] text-[16px] sm:text-[17px] lg:text-[18px] leading-relaxed font-normal text-justify break-words">
                    With a career spanning over three decades in the realm of
                    education, and a heart brimming with a passion for sports,
                    Ms. Indrani Sarkar stands as a visionary entrepreneur and a
                    stalwart in the field of sports management and grassroots
                    development. For over 30 years, Ms. Sarkar has been deeply
                    involved in shaping young minds through the avenue of
                    education. Her commitment to fostering holistic learning
                    experiences has left an indelible mark on countless
                    individuals.
                  </p>

                  <p className="text-[#585858] text-[16px] sm:text-[17px] lg:text-[18px] leading-relaxed font-normal text-justify break-words">
                    In 2017, Ms. Sarkar embarked on a transformative journey as
                    an entrepreneur, paving the way for K.K. Globus Initiative.
                    This endeavor has become a beacon of hope for India's youth
                    and grassroots sports, igniting the passion for sports among
                    school children across the nation. Ms. Sarkar's illustrious
                    journey includes accomplishments as an ex-international
                    footballer, coach of the Bengal women's team, and a manager
                    for the Indian women's football team. Currently, she wears
                    the hat of coach and manager for the East Bengal FC Women's
                    team, contributing to the growth of women's football in the
                    country.
                  </p>

                  <div
                    className="mt-6 lg:mt-8"
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    <h2 className="text-[22px] sm:text-[24px] lg:text-[26px] text-[#08121A] font-bold mb-2">
                      Ms. INDRANI SARKAR
                    </h2>
                    <p className="text-[16px] sm:text-[17px] lg:text-[18px] text-[#08121A] font-medium">
                      CEO & Managing Director, K.K. Globus Ventures
                    </p>
                  </div>
                </div>
              </div>

              {/* Image Section - Now second on desktop, first on mobile */}
              <div
                className="lg:col-span-1 flex justify-center lg:justify-end order-1 lg:order-2 h-full"
                data-aos="fade-left"
                data-aos-delay="150"
              >
                <div className="relative overflow-hidden rounded-lg shadow-lg w-full h-full  lg:max-w-none">
                  <img
                    src={CEOandDirectorImg}
                    alt="Ms. Indrani Sarkar"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurTeamInfoContainer2;